import { useEffect, useState } from 'react'

type OAuthFormProps = {
  webhookUrl?: string
  formatAuthorizationUrl: (webhookUrl: string) => string
}

export const GmailForm = ({ webhookUrl, formatAuthorizationUrl }: OAuthFormProps) => {
  const [authorizationUrl, setAuthorizationUrl] = useState('')

  useEffect(() => {
    if (webhookUrl) {
      setAuthorizationUrl(formatAuthorizationUrl(webhookUrl))
    }
  }, [webhookUrl])

  return (
    <div className="grid gap-2">
      {!webhookUrl && (
        <div className="text-center">
          <p className="text-sm text-gray-11">Enable the channel first to continue with the next step</p>
        </div>
      )}
      <button
        disabled={!webhookUrl}
        className="flex items-center justify-between rounded-md border-accent-9 bg-accent-9 text-white hover:border-accent-10 hover:bg-accent-10 hover:shadow-md"
        onClick={() => window.open(authorizationUrl, 'OAuth', 'width=650,height=800,popup=true')}
      >
        <div className="m-px flex h-12 w-12 items-center justify-center rounded-l-md bg-gray-1">
          <img className="h-5 w-5" src="/logos/google.png" alt="Google Logo" />
        </div>
        <div className="text-sm">Sign in with Google</div>
        <div />
      </button>
    </div>
  )
}
